import { useTranslation } from 'react-i18next';
import { Pressable, Text } from 'react-native';
import { useTheme } from '@/theme';

/** "Update" beside a book you're in: one tap to where you are now. */
export function UpdatePill({ title, onPress }: { title: string; onPress: () => void }) {
  const { t } = useTranslation();
  const { colors, fontSize, space } = useTheme();
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={t('myBooks.updateLabel', { title })}
      onPress={onPress}
      hitSlop={6}
      style={({ pressed }) => ({
        alignSelf: 'flex-start',
        minHeight: 36,
        paddingHorizontal: space.md,
        borderRadius: 18,
        borderWidth: 1,
        borderColor: colors.control,
        backgroundColor: colors.surface,
        justifyContent: 'center',
        opacity: pressed ? 0.7 : 1,
      })}
    >
      <Text style={{ color: colors.text, fontSize: fontSize.sm, fontWeight: '700' }}>{t('homeFeed.update')}</Text>
    </Pressable>
  );
}
